import { render, staticRenderFns } from "./SFretesCep.vue?vue&type=template&id=07397b52"
import script from "./SFretesCep.vue?vue&type=script&lang=js"
export * from "./SFretesCep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports